import React from 'react';
import { Container, Content, Header, ShimmerEffect } from './styles';

// import { Container } from './styles';

const LoadingState: React.FC = () => {
  return (
    <Container>
      <Header>
        <ShimmerEffect className="header-shimmer" />
      </Header>
      <Content>
        <ShimmerEffect className="content-shimmer" />
      </Content>
      <Header>
        <ShimmerEffect className="header-shimmer" />
      </Header>
      <Content>
        <ShimmerEffect className="content-shimmer" />
      </Content>
    </Container>
  );
};

export default LoadingState;
